import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useClosePartnerToggle } from './hooks';

export const ClosePartnerToggle: React.FC = () => {
  const { t } = useTranslation('companyDetails');
  const { isPartner, isPending, toggleClosePartner, canEdit } =
    useClosePartnerToggle();

  const label = t('CLOSE_PARTNER_TOGGLE.ARIA_LABEL');
  const tooltipLabel = isPartner
    ? t('CLOSE_PARTNER_TOGGLE.TOOLTIP.IS_PARTNER')
    : t('CLOSE_PARTNER_TOGGLE.TOOLTIP.NOT_PARTNER');

  return (
    <Tooltip label={tooltipLabel}>
      <Button
        size="xs"
        color="blue"
        variant={isPartner ? 'filled' : 'outline'}
        aria-label={label}
        loading={isPending}
        disabled={!canEdit}
        onClick={() => toggleClosePartner()}
      >
        <FontAwesomeIcon icon={isPartner ? faStarSolid : faStarRegular} />
      </Button>
    </Tooltip>
  );
};
